import React from "react";
import {useNavigate} from "react-router-dom";
import {cacheService} from "../../../services/cacheService";
import apiService from "../../../services/apiServices";
import {translationStore} from "../../../store/translationStore";
import {observer} from "mobx-react-lite";
import {unityLayoutStore} from "../../../store/unityLayoutStore";
import {threeCubeEnvStore} from "../../../store/threeCubeEnvStore";
import "./style.scss"

const Registration = observer(() => {
    const navigate = useNavigate();
    const {translationData} = translationStore;
    const setUserGuest = () => apiService.setUserGuest();
    const {setIsGuest} = unityLayoutStore;
    const {setPanoramicPopup} = threeCubeEnvStore;

    const handleClick = () => {
        navigate("/login");
    };

    const handleGuestClick = async () => {
        const {data: {data: {token, guest_id, username}}} = await setUserGuest();
        const lang = cacheService.get("Language");
        cacheService.clear();
        cacheService.set("Authorization", `Token ${token}`);
        cacheService.set("UserType", username);
        cacheService.set("Id", guest_id);
        cacheService.set("Language", lang);
        setIsGuest();
        setPanoramicPopup(true);
        navigate({pathname: "/dashboard"});
    };

    return (
        <div className="root-authorization-variants">
            <button type="button" className="root-authorization-with-email"
                    onClick={handleClick}>{translationData?.["use_your_email"]}</button>
            <span className="root-authorization-or-label">{translationData?.["or"]}</span>
            <button type="button" className="root-authorization-with-email magenta"
                    onClick={handleGuestClick}>{translationData?.["explore"] || "Explore"}
            </button>
        </div>
    );
});

export default Registration;
